import {
  QueryGenerateStaticMapUrlArgs,
  StaticMaps,
} from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/index.js'
import { useTribeClient } from '../../useTribeClient.js'

import { getStaticMapUrlKey } from './event.key.js'

export const useStaticMapUrl = (options: {
  variables: QueryGenerateStaticMapUrlArgs
  useQueryOptions?: UseQueryOptions<StaticMaps>
}) => {
  const { variables, useQueryOptions } = options || {}
  const key = getStaticMapUrlKey({ variables })
  const { client } = useTribeClient()

  return useQuery<StaticMaps>(
    key,
    () => client.events.generateStaticMapUrl(variables),
    useQueryOptions,
  )
}
